import { Badge } from 'react-bootstrap';
import InfoTip from '../components/InfoTip';
import { statusVariant } from '../format';

// Shared row fragments for the list pages.

export function StatusBadge({ status, extra }) {
  return (
    <span>
      <Badge bg={statusVariant(status)}>{status}</Badge>
      {extra}
    </span>
  );
}

export function OverdueBadge({ row }) {
  if (!row?.overdue) return null;
  return (
    <InfoTip text={row.dueAt ? `Was due ${new Date(row.dueAt).toLocaleDateString()}` : 'Past the settlement timeline'}>
      <Badge bg="warning" text="dark" className="ms-1">overdue</Badge>
    </InfoTip>
  );
}

// §A8 — "Remind owner" is only offered when the backend says canRemind (overdue + under the cap).
// When overdue but the cap is hit, show why instead of the button.
export function remindState(row) {
  const count = row?.ownerReminderCount ?? row?.ownerReminders?.length ?? 0;
  const max = row?.maxOwnerReminders ?? row?.remindersMax ?? 0;
  if (row?.canRemind) {
    return { show: true, label: 'Remind owner', hint: max ? `${count} of ${max} reminders used` : `${count} reminder(s) sent` };
  }
  if (row?.overdue && (row?.remindersRemaining === 0 || (max && count >= max))) {
    return { show: false, hint: `Reminder limit reached (${count}/${max}) — awaiting escalation` };
  }
  if (!row?.overdue && row?.dueAt) {
    return { show: false, hint: `Not due until ${new Date(row.dueAt).toLocaleDateString()}` };
  }
  return { show: false, hint: '' };
}
